<template>
    <path
        fill="currentColor"
        d="M12.81 7.548a1.87 1.87 0 1 1 2.644 2.644l-4.829 4.83a2.2 2.2 0 0 1-1.021.578l-1.498.375a.89.89 0 0 1-1.079-1.08l.374-1.497a2.2 2.2 0 0 1 .578-1.021zM7.5 8c.934 0 1.716.641 1.936 1.507L7.273 11.67c-.33.33-.58.727-.74 1.162A7 7 0 0 1 5 13c-1.175 0-2.27-.272-3.089-.77C1.091 11.73.5 10.965.5 10a2 2 0 0 1 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.502.997a2.252 2.252 0 1 1 0 4.503a2.252 2.252 0 0 1 0-4.503"
    />
</template>
